import { API } from "../../api";
import {
  mapStaffWebsiteTestimonial,
  toStaffWebsiteTestimonialPayload,
} from "../../../utils/staffWebsiteTestimonialAdapter";

export const staffWebsiteTestimonialsApi = API.injectEndpoints({
  endpoints: (builder) => ({
    listStaffWebsiteTestimonials: builder.query({
      query: (params = {}) => ({
        url: "/cooperatives/website/testimonials",
        method: "GET",
        params,
      }),
      transformResponse: (responseData) => ({
        items: (responseData?.data?.items || [])
          .map(mapStaffWebsiteTestimonial)
          .filter(Boolean),
      }),
      providesTags: [{ type: "StaffWebsiteTestimonials", id: "LIST" }],
    }),
    getStaffWebsiteTestimonial: builder.query({
      query: (id) => ({
        url: `/cooperatives/website/testimonials/${id}`,
        method: "GET",
      }),
      transformResponse: (responseData) =>
        mapStaffWebsiteTestimonial(responseData?.data),
      providesTags: (_r, _e, id) => [{ type: "StaffWebsiteTestimonials", id }],
    }),
    createStaffWebsiteTestimonial: builder.mutation({
      query: (values) => ({
        url: "/cooperatives/website/testimonials",
        method: "POST",
        body: toStaffWebsiteTestimonialPayload(values),
      }),
      transformResponse: (responseData) =>
        mapStaffWebsiteTestimonial(responseData?.data),
      invalidatesTags: [{ type: "StaffWebsiteTestimonials", id: "LIST" }],
    }),
    updateStaffWebsiteTestimonial: builder.mutation({
      query: ({ id, values }) => ({
        url: `/cooperatives/website/testimonials/${id}`,
        method: "PATCH",
        body: toStaffWebsiteTestimonialPayload(values),
      }),
      transformResponse: (responseData) =>
        mapStaffWebsiteTestimonial(responseData?.data),
      invalidatesTags: (_r, _e, arg) => [
        { type: "StaffWebsiteTestimonials", id: "LIST" },
        { type: "StaffWebsiteTestimonials", id: arg.id },
      ],
    }),
    deleteStaffWebsiteTestimonial: builder.mutation({
      query: (id) => ({
        url: `/cooperatives/website/testimonials/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "StaffWebsiteTestimonials", id: "LIST" }],
    }),
    publishStaffWebsiteTestimonial: builder.mutation({
      query: (id) => ({
        url: `/cooperatives/website/testimonials/${id}/publish`,
        method: "POST",
      }),
      transformResponse: (responseData) =>
        mapStaffWebsiteTestimonial(responseData?.data),
      invalidatesTags: [{ type: "StaffWebsiteTestimonials", id: "LIST" }],
    }),
    unpublishStaffWebsiteTestimonial: builder.mutation({
      query: (id) => ({
        url: `/cooperatives/website/testimonials/${id}/unpublish`,
        method: "POST",
      }),
      transformResponse: (responseData) =>
        mapStaffWebsiteTestimonial(responseData?.data),
      invalidatesTags: [{ type: "StaffWebsiteTestimonials", id: "LIST" }],
    }),
  }),
});

export const {
  useListStaffWebsiteTestimonialsQuery,
  useGetStaffWebsiteTestimonialQuery,
  useCreateStaffWebsiteTestimonialMutation,
  useUpdateStaffWebsiteTestimonialMutation,
  useDeleteStaffWebsiteTestimonialMutation,
  usePublishStaffWebsiteTestimonialMutation,
  useUnpublishStaffWebsiteTestimonialMutation,
} = staffWebsiteTestimonialsApi;
